var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"aria-labelledby":_vm.titleId,"height":_vm.height,"viewBox":`0 0 ${_vm.viewBoxWidth} ${_vm.viewBoxHeight}`,"width":_vm.width,"role":"img","xmlns":"http://www.w3.org/2000/svg"}},[_c('title',{attrs:{"id":_vm.titleId,"lang":"en"}},[_vm._v(_vm._s(_vm.iconName)+" icon")]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }